import { useState } from 'react';
import { matchPath, useLocation, Link } from 'react-router-dom';
import {
  AppBar,
  Box,
  CssBaseline,
  Toolbar,
  Collapse,
  List,
  ListItem,
  Button,
  Typography
} from '@mui/material'
import { Logout } from '@mui/icons-material'
import Hamburger from 'hamburger-react'
import { useWallet } from '@utils/walletHelper'
import navbarConfig from '../../config/navbar'
import LogoIcon from '@images/presail_logo.png'
import MetamaskIcon from '@images/ico_metamask.png'
import './Layout.scss'

const Header = () => {
  const pathname = useLocation().pathname
  const { connected, connectHandler, disconnectHandler, walletAddress } = useWallet()
  const [isOpen, setOpen] = useState(false)
  const [isDisconnect, setIsDisconnect] = useState(false)

  const displayAddress = (address) => {
    return address.slice(0, 4) + '...' + address.slice(-4)
  }

  return (
    <Box>
      <CssBaseline />
      <AppBar
        position="fixed"
        elevation={0}
        sx={{ zIndex: 10 }}
      >
        <Box className="header">
          <Toolbar
            className="navbar"
          >
            <Link
              className="logo"
              to="/"
            >
              <img src={LogoIcon} alt="logo icon" />
            </Link>
            <Collapse
              in={true}
            >
              <List className="menu">
                {connected &&
                  navbarConfig.map((nav, index) => {
                    const currentPath = pathname === '/' ? '/all_deals' : pathname
                    const active = !!matchPath(nav.path, currentPath);

                    return (
                      <ListItem key={index} className="menu-item">
                        <Link
                          to={nav.path}
                          className={`no_underline text-white ${active ? "active" : ""}`}
                        >
                          {nav.title}
                        </Link>
                      </ListItem>
                    )
                  })
                }
                <ListItem className="menu-item">
                  {connected ? (
                    <Box sx={{ position: "relative" }}>
                      <Box className="login-button" onClick={() => setIsDisconnect(!isDisconnect)}>
                        <Typography>
                          {displayAddress(walletAddress)}
                        </Typography>
                        <Box sx={{ position: "relative", pl: 1, display: "flex" }}>
                          <img src={MetamaskIcon} alt="Metamask icon" />
                          <Box className="connected-status"></Box>
                        </Box>
                      </Box>
                      {isDisconnect && (
                        <Box className="disconnect-button" onClick={() => { disconnectHandler(); setIsDisconnect(false) }}>
                          <Typography>
                            Disconnect
                          </Typography>
                          <Logout sx={{ height: "18px" }} />
                        </Box>
                      )}
                    </Box>
                  ) : (
                    <Button
                      variant='outlined'
                      className="connect-wallet btn-lg"
                      onClick={connectHandler}
                    >
                      Connect Wallet
                    </Button>
                  )}
                </ListItem>
                <ListItem
                  className="hamburger-menu"
                >
                  <Hamburger toggled={isOpen} toggle={setOpen} />
                </ListItem>
              </List>
            </Collapse>
          </Toolbar>
        </Box>
        {isOpen && (
          <Box className="mobile-panel">
            <Collapse
              in={true}
            >
              <List className="menu">
                {connected &&
                  navbarConfig.map((nav, index) => {
                    const currentPath = pathname === '/' ? '/all_deals' : pathname
                    const active = !!matchPath(nav.path, currentPath);

                    return (
                      <ListItem key={index}>
                        <Link
                          to={nav.path}
                          className={`no_underline text-white ${active ? "active" : ""}`}
                        >
                          {nav.title}
                        </Link>
                      </ListItem>
                    )
                  })
                }
                <ListItem>
                  {connected ? (
                    <Box sx={{ position: "relative" }}>
                      <Box className="login-button" onClick={() => setIsDisconnect(!isDisconnect)}>
                        <Typography>
                          {displayAddress(walletAddress)}
                        </Typography>
                        <Box sx={{ position: "relative", pl: 1, display: "flex" }}>
                          <img src={MetamaskIcon} alt="Metamask icon" />
                          <Box className="connected-status"></Box>
                        </Box>
                      </Box>
                      {isDisconnect && (
                        <Box className="disconnect-button" onClick={() => { disconnectHandler(); setIsDisconnect(false) }}>
                          <Typography>
                            Disconnect
                          </Typography>
                          <Logout sx={{ height: "18px" }} />
                        </Box>
                      )}
                    </Box>
                  ) : (
                    <Button
                      variant='outlined'
                      className="connect-wallet btn-lg"
                      onClick={connectHandler}
                    >
                      Connect Wallet
                    </Button>
                  )}
                </ListItem>
              </List>
            </Collapse>
          </Box>
        )}
      </AppBar>
    </Box>
  )
}

export default Header;